export const cookiePolicy = `
We use cookies and similar technologies to run this website, keep you signed in, and — only with your permission — understand how the site is used.

You can accept all cookies or continue with necessary cookies only. You can change your choice at any time via Cookie settings in the footer or the button on this page.

## What are cookies?

Cookies are small text files stored on your device. We also use similar storage such as localStorage. Under EU rules, we only place non-essential cookies after you agree.

## Your choices

- **Necessary only** — the site works (login, security, payments, language). We do not load Google Analytics, Google Tag Manager, or advertising tags.
- **Accept all** — necessary cookies plus analytics and advertising cookies (Google Analytics, Google Tag Manager if configured, and Google Ads conversion tags).

## Cookies and storage we use

### Necessary

These are required for the service you request. They do not require consent.

| Name | Purpose | Duration | Set by |
| --- | --- | --- | --- |
| \`osc_cookie_consent\` | Stores your cookie choice | 1 year | Opensource.clinic |
| Firebase Auth cookies / IndexedDB | Keeps you signed in | Session / persistent (Firebase) | Google Firebase |
| Stripe \`__stripe_mid\`, \`__stripe_sid\` | Payment security and fraud prevention on checkout | Up to 1 year / session | Stripe, only on payment pages |

### Preferences (first-party)

These remember how you use the site. They are not used for advertising.

| Name | Purpose | Duration | Set by |
| --- | --- | --- | --- |
| \`language\` (localStorage) | Remembers English or Dutch | Until you change it | Opensource.clinic |
| \`app.settings\` (localStorage) | Theme and layout preferences | Until you reset them | Opensource.clinic |

### Analytics and advertising (only after Accept all)

These are not loaded if you choose Necessary only

| Name | Purpose | Duration | Set by |
| --- | --- | --- | --- |
| \`_ga\`, \`_ga_*\` | Google Analytics 4 — page views and usage | Up to 2 years | Google |
| Google Tag Manager cookies (if configured) | Loads tags that you approved | Varies | Google |
| Google Ads cookies (e.g. conversion tags) | Measures campaign conversions (for example after a purchase or package enquiry) | Varies | Google |
| \`utm_source\` (localStorage) | Stores campaign source from the URL | Until cleared | Opensource.clinic |

## Third parties

- **Google** — Analytics, optional Tag Manager, and Ads conversions. See [Google’s privacy policy](https://policies.google.com/privacy) and [how Google uses data](https://policies.google.com/technologies/partner-sites).
- **Stripe** — payments. See [Stripe’s privacy policy](https://stripe.com/privacy).
- **Firebase (Google)** — authentication. See [Firebase privacy](https://firebase.google.com/support/privacy).

We do not sell your personal data.

## How to change or withdraw consent

Use **Cookie settings** in the website footer, or the button on this page. Choosing Necessary only after you previously accepted all will reload the site without analytics and advertising tags.

You can also delete cookies in your browser settings.

## Related documents

- [Privacy Policy](/privacy-policy)
- [Data Privacy](/dataprivacy)
- [Terms and conditions](/legalnotice)

## Contact

Questions about cookies or privacy: [info@opensource.clinic](mailto:info@opensource.clinic) or [WhatsApp](https://wa.me/31639202608).

*Last updated: 19 August 2026.*
`;
